export const environment = {
  production: true,
  preproduccion: false
};
